"use client";

import { BigMath } from "@yn/utils";

function normalizeAmount( value: number | string | undefined ) {
    if ( value === undefined || value === "" ) return 0;
    return value;
}

export function centToUsdAmount( value: number | string | undefined ) {
    return Number( BigMath.div( normalizeAmount( value ), 100 ) );
}

export function usdToCentAmount( value: number | string | undefined ) {
    return Number( BigMath.times( normalizeAmount( value ), 100 ) );
}
